import { useQuery } from '@tanstack/react-query';
import useEventTicketQueries from '@dashboard/hooks/queries/useEventTicketQueries';
import useProductQueries from '@dashboard/hooks/queries/useProductQueries';
import { pageTicketTypesKey, productKey } from '@dashboard/lib/queryKeys';
import { useOrderBumps } from '@dashboard/scenes/PageEdit/scenes/PageProduct/components/OrderBumps/useOrderBumpMutations';

// Page summaries from the search carry prices without their ids, so those load the product.
export const usePagePrices = (page, { enabled = true } = {}) => {
  const { getProduct } = useProductQueries();
  const product = page.product;
  const hasPriceIds = (product?.prices ?? []).every(price => price._id);
  const { data, isLoading } = useQuery({
    queryKey: productKey(product?._id),
    queryFn: () => getProduct(product._id),
    enabled: enabled && !!product?._id && !hasPriceIds,
  });
  return hasPriceIds
    ? { product, isLoading: false }
    : { product: data, isLoading: enabled && isLoading };
};

export const usePageTickets = (page, { enabled = true } = {}) => {
  const { getTicketTypesForPage } = useEventTicketQueries();
  const { data = [], isLoading } = useQuery({
    queryKey: pageTicketTypesKey(page._id),
    queryFn: () => getTicketTypesForPage(page._id),
    enabled,
  });
  return { ticketTypes: data, isLoading: enabled && isLoading };
};

export const usePageBumps = (page, { enabled = true } = {}) => {
  const { orderBumps, isLoading } = useOrderBumps(page._id, { enabled });
  return { orderBumps, isLoading: enabled && isLoading };
};
